import { render, staticRenderFns } from "./TiersSelection.vue?vue&type=template&id=1d99897d&"
import script from "./TiersSelection.vue?vue&type=script&lang=js&"
export * from "./TiersSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports